import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/right_arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/market-analysis.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/consumer/patient-insights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/financialService/competitive_benchmarking.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/advanced.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brand_research.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/industries.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/managers.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/brandResearch/stakeholders.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/consumer_research.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/consumerResearch/consumerinsights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/market_assessment.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/marketAssessment/sales_and_marketing.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/mystery_shopping.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/new_product_development.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/product_insights.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/foodandbeverage.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/franchise.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/ourExprience.png");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/petfood.svg");
;
import(/* webpackMode: "eager" */ "/app/public/researchAndConsulting/sensoryResearch/skincare.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
